/** @jsxImportSource @emotion/react */
import { hooks as commonHooks } from '@sitebuilder/common';
import SpinnerIcon from '../SpinnerIcon';
import SideBarAccordion from '../SideBarAccordion';
import VersionHistory from './VersionHistory';
import ItemInformation from './ItemInformation';

interface VersionsAccordionGroupProps {
    onClickAccordion: (e: string) => any;
    onClickRestoreVersion: (e: string) => any;
    selectedItems: string[];
    type: string;
    items?: any;
    itemVersions?: any;
    accordionActiveKey?: string;
    itemVersionsLoading?: boolean;
    urlState?: string;
}

const VersionsAccordionGroup = ({
    selectedItems,
    type,
    items,
    itemVersions,
    itemVersionsLoading,
    accordionActiveKey,
    onClickAccordion,
    onClickRestoreVersion,
    urlState,
}: VersionsAccordionGroupProps) => {
    const i18n = commonHooks.useLocalization();

    return (
        <div className="versions-accordion-group">
            {selectedItems.length === 1 && (
                <>
                    <SideBarAccordion
                        toggleTitle={i18n.t(`${type}_info_accordion_title`)}
                        eventKey="0"
                        accordionActiveKey={accordionActiveKey}
                        onClickAccordion={onClickAccordion}
                        itemInfo={
                            items?.length &&
                            items.filter((i: any) => i.name === selectedItems[0])[0]
                        }
                    >
                        <ItemInformation
                            itemInfo={
                                items?.length &&
                                items.filter((i: any) => i.name === selectedItems[0])[0]
                            }
                            itemType={type}
                            urlState={urlState}
                        />
                    </SideBarAccordion>
                    <SideBarAccordion
                        toggleTitle={i18n.t('version_history')}
                        eventKey="1"
                        accordionActiveKey={accordionActiveKey}
                        onClickAccordion={onClickAccordion}
                    >
                        {itemVersionsLoading ? (
                            <div className="loading">
                                <SpinnerIcon />
                            </div>
                        ) : (
                            <>
                                <VersionHistory
                                    versions={itemVersions}
                                    onClickRestoreVersion={onClickRestoreVersion}
                                />
                            </>
                        )}
                    </SideBarAccordion>
                </>
            )}

            {selectedItems.length > 1 && (
                <SideBarAccordion
                    toggleTitle={i18n.t(`${type}_info_accordion_title`)}
                    eventKey="0"
                    accordionActiveKey={accordionActiveKey}
                    onClickAccordion={onClickAccordion}
                    itemInfo={
                        items?.length && items.filter((i: any) => i.name === selectedItems[0])[0]
                    }
                >
                    <ItemInformation
                        itemInfo={
                            items?.length &&
                            items.filter((i: any) => i.name === selectedItems[0])[0]
                        }
                        multipleItemsInfo={
                            items?.length &&
                            items.filter((i: any) => selectedItems.includes(i.name))
                        }
                        itemType={type}
                        urlState={urlState}
                    />
                </SideBarAccordion>
            )}
        </div>
    );
};

export default VersionsAccordionGroup;
